export default {
  pagination: {
    itemsPerPage: '{size} 条/页',
    jumpTo: '跳至',
    page: '页',
    prev: '上一页',
    next: '下一页',
    total: '共 {total} 项数据',
  },
  cascader: {
    empty: '暂无数据',
    loadingText: '加载中',
  },
  calendar: {
    fillWithZero: true,
    yearSelection: '{year} 年',
    monthSelection: '{month} 月',
    yearRadio: '年',
    monthRadio: '月',
    hideWeekend: '隐藏周末',
    showWeekend: '显示周末',
    today: '今天',
    thisMonth: '本月',
    week: '一,二,三,四,五,六,日',
    cellMonth: '一月,二月,三月,四月,五月,六月,七月,八月,九月,十月,十一月,十二月',
  },
  transfer: {
    title: '{checked} / {total} 项',
    empty: '暂无数据',
    placeholder: '请输入关键词搜索',
  },
  timePicker: {
    nowtime: '此刻',
    confirm: '确定',
    anteMeridiem: '上午',
    postMeridiem: '下午',
    placeholder: '选择时间',
  },
  dialog: {
    confirm: '确认',
    cancel: '取消',
  },
  drawer: {
    confirm: '确认',
    cancel: '取消',
  },
  popconfirm: {
    confirm: '确定',
    cancel: '取消',
  },
  table: {
    empty: '暂无数据',
    // 展开和收起图标（使用收起图标）
    expandIcon: null,
    // 排序图标（使用降序图标）
    sortIcon: null,
  },
  select: {
    empty: '暂无数据',
    loadingText: '加载中',
    // 清除按钮
    clearIcon: null,
  },
  tree: {
    empty: '暂无数据',
    // 目录层级图标
    folderIcon: null,
  },
  treeSelect: {
    empty: '暂无数据',
    loadingText: '加载中',
  },
  datePicker: {
    placeholder: {
      date: '请选择日期',
      month: '请选择月份',
      year: '请选择年份',
    },
    weekdays: ['一', '二', '三', '四', '五', '六', '日'],
    months: ['1 月', '2 月', '3 月', '4 月', '5 月', '6 月', '7 月', '8 月', '9 月', '10 月', '11 月', '12 月'],
    firstDayOfWeek: 0,
    rangeSeparator: ' 至 ',
    direction: 'ltr',
    format: 'YYYY-MM-DD',
    dayAriaLabel: '日',
    weekAbbreviation: '周',
    yearAriaLabel: '年',
    monthAriaLabel: '月',
    confirm: '确定',
    selectTime: '选择时间',
    selectDate: '选择日期',
    nextYear: '下一年',
    preYear: '上一年',
    nextMonth: '下个月',
    preMonth: '上个月',
    preDecade: '上个十年',
    nextDecade: '下个十年',
    now: '当前',
  },
  steps: {},
  upload: {
    sizeLimitMessage: '图片大小不能超过 {sizeLimit}',
  },
};
